import React, { useEffect, useState } from 'react';
import { PackageIcon, UtensilsIcon, AlertTriangleIcon, AlertCircleIcon, XCircleIcon, Loader2Icon } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { InventoryDashboardStats } from './types';
interface Props {
  restaurantId: string;
}
export function InventoryDashboard({
  restaurantId
}: Props) {
  const [stats, setStats] = useState<InventoryDashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    async function fetchStats() {
      try {
        setLoading(true);
        const {
          data,
          error
        } = await supabase.from('v_inventory_dashboard').select('*').eq('restaurant_id', restaurantId).single();
        if (error) throw error;
        setStats(data);
      } catch (err: any) {
        console.error('Error fetching inventory stats:', err);
        setError(err.message || 'Error al cargar el resumen');
      } finally {
        setLoading(false);
      }
    }
    fetchStats();
  }, [restaurantId]);
  if (loading) {
    return <div className="flex items-center justify-center p-12" data-id="element-287">
        <Loader2Icon className="w-8 h-8 text-dorado animate-spin" data-id="element-288" />
      </div>;
  }
  if (error) {
    return <div className="p-6 bg-red-500/10 border border-red-500/20 rounded-xl text-red-400 text-center" data-id="element-289">
        <AlertCircleIcon className="w-8 h-8 mx-auto mb-2 opacity-80" data-id="element-290" />
        <p data-id="element-291">{error}</p>
      </div>;
  }
  if (!stats) return null;
  const cards = [{
    title: 'Total Ingredientes',
    value: stats.total_ingredients,
    icon: PackageIcon,
    color: 'text-emerald-400',
    bg: 'bg-emerald-400/10',
    border: 'border-emerald-400/20'
  }, {
    title: 'Total Platos (Menú)',
    value: stats.total_menu_items,
    icon: UtensilsIcon,
    color: 'text-blue-400',
    bg: 'bg-blue-400/10',
    border: 'border-blue-400/20'
  }, {
    title: 'Ingredientes Stock Bajo',
    value: stats.low_stock_count,
    icon: AlertTriangleIcon,
    color: 'text-dorado',
    bg: 'bg-dorado/10',
    border: 'border-dorado/20'
  }, {
    title: 'Platos con Inventario Bajo',
    value: stats.low_inventory_items,
    icon: AlertCircleIcon,
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    border: 'border-orange-400/20'
  }, {
    title: 'Platos Agotados (Stop)',
    value: stats.stop_offering_count,
    icon: XCircleIcon,
    color: 'text-red-400',
    bg: 'bg-red-400/10',
    border: 'border-red-400/20'
  }];
  return <div className="space-y-6" data-id="element-292">
      <h2 className="text-xl font-heading font-bold text-white" data-id="element-293">
        Resumen de Inventario
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4" data-id="element-294">
        {cards.map((card, idx) => {
        const Icon = card.icon;
        return <div key={idx} className={`bg-surface border ${card.border} rounded-xl p-5 flex flex-col items-center text-center transition-all hover:-translate-y-1 hover:shadow-lg`} data-id="element-295">
              <div className={`w-12 h-12 rounded-full ${card.bg} ${card.color} flex items-center justify-center mb-3`} data-id="element-296">
                <Icon className="w-6 h-6" data-id="element-297" />
              </div>
              <h3 className="text-sm text-gray-400 font-medium mb-1" data-id="element-298">
                {card.title}
              </h3>
              <p className={`text-3xl font-bold ${card.color}`} data-id="element-299">{card.value}</p>
            </div>;
      })}
      </div>
    </div>;
}